<template>
  <!-- Navigation Drawer -->
  <v-navigation-drawer
    v-model="model"
    app
    temporary
    right
    :width="260"
    style="z-index: 1000"
  >
    <v-list-item @click="$emit('openSettings')" v-if="isCanteen">
      <v-list-item-icon>
        <v-icon>mdi-cog</v-icon>
      </v-list-item-icon>
      <v-list-item-title style="font-weight: bold">
        {{ $t("settings") }}
      </v-list-item-title>
    </v-list-item>
    <v-divider></v-divider>
    <v-list dense>
      <!-- Highlighted Settings Item -->
      <v-list-item
        v-for="route in availableRoutes"
        :key="route.name"
        :to="{ name: route.name }"
      >
        <v-list-item-icon>
          <v-icon>{{ route.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t(route.displayName) }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="logout">
        <v-list-item-icon>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Odjava</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import { allRoutes } from "@/router";

export default {
  name: "PaymentDrawer",
  mixins: [hasModel],
  data() {
    return {};
  },
  methods: {
    logout() {
      localStorage.removeItem("restoran-token");
      this.deleteCookie("restoran-token");
      this.$store.commit("user/LOGOUT", null);
      this.$store.commit("SAVE_RESTAURANT", null);
      this.$store.commit("SAVE_COMPANY", null);
      this.$router.push({ name: "auth-login" });
    },
    deleteCookie(name) {
      document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    },
  },
  computed: {
    isCanteen() {
      return ["canteen", "naplata2"].includes(this.$route.name);
    },
    availableRoutes() {
      return allRoutes().filter((route) => {
        const ruleGate = route.rules.some((rule) => {
          const roleGate = rule.roles.includes(this.$store.state.user.user?.type);
          const companyGate = rule.companyRules.every(
            (type) => this.$store.state.company[type]
          );
          const restaurantGate = rule.restaurantRules.every(
            (type) => this.$store.state.restaurant[type]
          );
          const userGate = rule.userRules.every(
            (type) => this.$store.state.user.user?.type === type
          );
          return roleGate && companyGate && restaurantGate && userGate;
        });
        const roleGate = route.roles.includes(this.$store.state.user.user?.type);
        const permissionGate = route.permissions.every(
          (perm) => this.$store.state.user.user[perm]
        );
        if (route.rules.length) {
          return ruleGate;
        }
        return roleGate && permissionGate;
      });
    },
  },
};
</script>
